import { cx } from '@vizit/theme';
import * as React from 'react';
import {
  Popover as AriaPopover,
  type PopoverProps as AriaPopoverProps,
  composeRenderProps,
} from 'react-aria-components';

interface PopoverProps extends AriaPopoverProps {}

function Popover(props: PopoverProps, ref: React.ForwardedRef<HTMLElement>) {
  const { className: classNameProp, ...other } = props;

  return (
    <AriaPopover
      ref={ref}
      className={composeRenderProps(classNameProp, (className) =>
        cx(
          'z-50 bg-primary text-primary border border-primary',
          /* Entering */
          'data-[entering]:animate-in data-[entering]:fade-in-0 data-[entering]:zoom-in-95',
          /* Exiting */
          'data-[exiting]:animate-out data-[exiting]:fade-out-0 data-[exiting]:zoom-out-95',
          /* Placement */
          'data-[placement=bottom]:slide-in-from-top-2 data-[placement=left]:slide-in-from-right-2 data-[placement=right]:slide-in-from-left-2 data-[placement=top]:slide-in-from-bottom-2',
          className,
        ),
      )}
      {...other}
    />
  );
}

const _Popover = React.forwardRef<HTMLElement, PopoverProps>(Popover);

export type { PopoverProps };
export { _Popover as Popover };
